export default __webpack_public_path__ + "static/ca21a16e1277fa9c8e9ca7e1c2f1f078.png";